// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"486":"33b0b380","514":"438a8ae9","645":"f7d2dd16","787":"77677336","800":"dea7f2d3"}[chunkId] + ".chunk.js";
};